export default function Script({ children }) {
	const __html = children.replace( /\s+/g, ' ' ).trim()
	return <script dangerouslySetInnerHTML={{ __html }} />
}
